// RiaAgreementController
app.controller('RiaAgreementController', ['$scope', 'sessionService', 'WdHttpService', '$routeParams', '$location', '$timeout', 'config', 'analyticsService', 'tempStorageService', '$ocLazyLoad',
    function ($scope, sessionService, WdHttpService, $routeParams, $location, $timeout, config, analyticsService, tempStorageService, $ocLazyLoad) {
        $ocLazyLoad.load(config.SIGNDESK_SDK_URL);
        // Init 
        $scope.init = async function () {
            $scope.showPageLoader();
            await $scope.fetchAdviserSiteDetails();
            $scope.username = sessionService.get("cognito_username");
            let fallback = $routeParams.fallback == "true" ? true : false;
            if ($scope.isFallbackDisabled() && fallback) {
                fallback = false;
                $scope.showErrorPopup("Your Agreement is not signed, please reach out to us at support@wealthdesk.in or +91 8588 00 8835. Without Agreement signing you cannot proceed.", () => window.location.href = '/contact-us');
                return
            }

            $scope.userRiskValue = await WdHttpService._get_user_risk_profile(true);
            $scope.fundRiskValue = sessionService.get('fund-risk');
            $scope.isAdviserResearchAnalyst = sessionService.get('adviser-type');

            if ($scope.fundRiskValue == undefined || $scope.isAdviserResearchAnalyst == null) {
                console.log('fetching data from server for fund risk and isAdviserResearchAnalyst');
                // get fund details using $routeParams.fundName, $routeParams.adviserUsername
                var data = {
                    q: "fundName:" + $routeParams.fundName,
                    f: "web_admin:" + $scope.webadminName
                }
                // Search the fund and get the amount of fee to be paid.
                await WdHttpService._get_funds(data)
                    .then(function (response) {
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length == 1) {
                            $scope.fund_details = response.data.Items[0];
                        } else if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == $routeParams.fundName) {
                                    $scope.fund_details = fund;
                                }
                            });
                        } else {
                            $scope.fund_details = undefined;
                            $scope.showErrorPopup('This WealthBasket seems to be closed for fresh subscriptions now. Kindly contact support if required (+91 85880 08835).', () => window.location.href = '/');
                        }
                    });

                if ($scope.fund_details.risk && $scope.fund_details.wealthBasketType) {
                    $scope.fundRiskValue = $scope.fund_details.risk;
                    $scope.isAdviserResearchAnalyst = $scope.fund_details.wealthBasketType == 'RA' ? true : false;
                } else {
                    $scope.showErrorPopup('The risk classification for this WealthBasket is missing. Kindly contact our team at +91 85880 08835');
                    $scope.hidePageLoader();
                    throw 'WealthBasket Risk is undefined, cannot proceed';
                }
            }

            $scope.isRiskHigher = isFundRiskHigher($scope.fundRiskValue, $scope.userRiskValue);

            if ($scope.isEsignEnabled() && !fallback) {
                if ($scope.isRiskHigher && $scope.isAdviserResearchAnalyst == false) {
                    $('#riskDisclaimer').modal('show');
                } else {
                    $scope.initiateSignDeskFlow();
                }
            } else {
                $scope.initiateWDAgreementFlow();
            }
        }

        $scope.initiateSignDeskFlow = async function () {
            var data = {
                adviserUsername: $routeParams.adviserUsername
            };
            $scope.showPageLoader("Preparing your agreement document...");
            await WdHttpService._post_initiate_esign(data)
                .then(async response => {
                    if (response.docket_id && response.document_id && response.signer_id) {
                        var clientData = {
                            document_id: response.document_id,
                            signer_id: response.signer_id,
                            docket_id: response.docket_id,
                            id: response.application_id,
                            "jqueryPath": window.location.origin + "/assets/js/bootstrap.min.js",
                            getWidgetToken: async function (widgetTokenString) {
                                var data = {
                                    "widget_token": widgetTokenString,
                                    "docket_id": response.docket_id,
                                    "adviserUsername": $routeParams.adviserUsername
                                }
                                WdHttpService._get_widget_token_validation(data)
                                    .then(response => {
                                        if (response.status != 'success') {
                                            $scope.startFallback();
                                        } else {
                                            $scope.hidePageLoader();
                                        }
                                    }).catch(error => {
                                        console.log(error);
                                        $scope.startFallback();
                                    });
                                // no need to return any value.
                            },
                            signatureStatus: async function (result) {
                                $scope.showPageLoader();
                                /**
                                 * possible result object 1
                                 * document_id: "610a35141404235d5628c5e0"
                                 * result: "document not signed "
                                 * signer_id: "610a35141404235d5628c5e3"
                                 * status: "failed"
                                 */

                                /**
                                 * possible result object 2
                                 * document_id: "610a92f95d6a5406d055fb4b"
                                    result: "document not signed"
                                    signer_id: "610a92f95d6a5406d055fb4e"
                                    status: "rejected"
                                    validation_error:
                                        name_as_per_aadhaar:
                                            message: "The name did not match the details as per Aadhaar records"
                                            percentage_match: 0
                                            value_as_per_aadhaar: "Name on Aadhaar"
                                            value_passed: "SomeName Surname"
                                 */
                                if (result.status == 'success') {
                                    $scope.redirectToPayment();
                                } else {
                                    $scope.hidePageLoader();
                                    $scope.signdeskErrorMessage = undefined;
                                    if (result.validation_error) {
                                        $scope.signdeskErrorMessage = '';
                                        for (const key in result.validation_error) {
                                            if (Object.hasOwnProperty.call(result.validation_error, key)) {
                                                $scope.signdeskErrorMessage += result.validation_error[key].message + '. ';
                                            }
                                        }
                                    }
                                    if ($scope.signdeskErrorMessage)
                                        if ($scope.signdeskErrorMessage.includes('The name did not match the details as per Aadhaar records')) {
                                            $scope.nameMatchIssue = true;
                                            $scope.signdeskErrorMessage = "Name as per Aadhaar does not match with KYC records";
                                        }

                                    $scope.$evalAsync();
                                    await $('#signdeskFailure').modal({
                                        backdrop: 'static',
                                        keyboard: false,
                                        show: true
                                    });
                                }
                                return; // no need to return any value.
                            },
                            errorLog: async function (error) {
                                console.log(error);
                                console.log('signdesk error');
                                $scope.hidePageLoader();
                                $scope.signdeskErrorMessage = error;
                                await $('#signdeskFailure').modal({
                                    backdrop: 'static',
                                    keyboard: false,
                                    show: true
                                });
                            }
                        }
                        esignWidgetCall(clientData);
                    } else {
                        $scope.hidePageLoader();
                        $scope.signdeskErrorMessage = undefined;
                        await $('#signdeskFailure').modal({
                            backdrop: 'static',
                            keyboard: false,
                            show: true
                        });
                    }
                }).catch(error => {
                    console.log(error);
                    if (typeof error == 'string' && error.includes("already signed")) {
                        $scope.redirectToPayment();
                    } else {
                        $scope.showErrorPopup(error);
                    }
                    $scope.hidePageLoader();
                });
        }

        $scope.initiateWDAgreementFlow = async function () {
            let distributorName = $scope.isDistributor ? sessionService.get("distributorName") : $routeParams.adviserUsername;

            if ($scope.isAdviserResearchAnalyst == false) {
                $scope.agreementButtonText = 'I Agree to End User Agreement Terms using <br/> OTP based authentication';
                $scope.isRiskHigher = isFundRiskHigher($scope.fundRiskValue, $scope.userRiskValue);
            } else {
                $scope.agreementButtonText = 'I Agree to End User Agreement Terms & Proceed';
                $scope.isRiskHigher = false;
            }

            // Get the Agreement Copy from the Server Side.
            await WdHttpService._get_user_adviser_agreement($routeParams.fundName, $routeParams.adviserUsername, distributorName)
                .then(response => {
                    $scope.agreementText = response.agreementCopy;
                    $scope.$evalAsync();
                })
                .catch(error => {
                    console.log(error);
                    $scope.showErrorPopup("Fetching agreement failed, please reach out to us at support@wealthdesk.in or +91 8588 00 8835. Without Agreement signing you cannot proceed.", () => window.location.href = '/contact-us');
                });

            $scope.hidePageLoader();
        }

        $scope.isEsignEnabled = function () {
            return $scope.isAdviserPropertyEnabled($routeParams.adviserUsername, 'isEsignEnabled')
        }

        $scope.isSignDeskAgreementEnabled = function () {
            if ($scope.isFallbackInitiated()) {
                return false;
            }
            return $scope.isEsignEnabled();
        }

        $scope.isFallbackInitiated = function () {
            return $routeParams.fallback == "true" ? true : false;
        }

        $scope.isFallbackDisabled = function () {
            return $scope.isAdviserPropertyEnabled($routeParams.adviserUsername, 'isEsignFallBackDisabled');
        }

        $scope.sendAgreementOtp = async function () {
            $scope.showLoading("#agreementSubmitButton");
            if ($scope.isAdviserResearchAnalyst == false) {
                if ($scope.fundRiskValue == undefined || $scope.userRiskValue == undefined) {
                    let errReason = '';
                    if (!$scope.fundRiskValue)
                        errReason += 'FR1';
                    if (!$scope.userRiskValue) {
                        console.log('fetching data from server for user risk');
                        $scope.userRiskValue = await WdHttpService._get_user_risk_profile(false);
                        if (!$scope.userRiskValue)
                            errReason += 'UR1';
                    }
                    if (errReason != '') {
                        $scope.showErrorPopup('Some attribute is missing. Cannot proceed, Please re-login and retry once - Error ' + errReason);
                        $scope.stopLoading("#agreementSubmitButton");
                        return;
                    }
                }
                var profileData = await WdHttpService._get_dynamodb_user_profile();
                $scope.mobile = profileData.phoneNumber ? profileData.phoneNumber.replace('+91', '') : undefined;
                await WdHttpService._post_user_adviser_agreement_initiate($routeParams.fundName, $routeParams.adviserUsername, $scope.mobile, $scope.isAdviserResearchAnalyst)
                    .then(response => {
                        //open otp modal
                        $('#otpModal').modal({ backdrop: 'static' });
                    }).catch(error => {
                        console.log(error);
                        $scope.showErrorPopup(error);
                    });
            } else if ($scope.isAdviserResearchAnalyst) {
                $scope.complete_agreement_signing('111111');
            }

            $scope.stopLoading("#agreementSubmitButton");
        }

        $scope.resendAgreementOtp = async function () {
            $scope.showLoading("#otpResendButton");
            await WdHttpService._post_user_adviser_agreement_initiate($routeParams.fundName, $routeParams.adviserUsername, $scope.mobile, $scope.isAdviserResearchAnalyst)
                .then(response => {
                    $scope.otpErrorMessage = "OTP has been sent again. Kindly wait for 30 seconds before requesting for a new OTP.";
                    $scope.disableOtpResend = true;
                    $scope.showOtpErrorMessage = true;
                    $scope.agreementOtpField = '';
                    $scope.$evalAsync();
                    $timeout(function () {
                        $scope.otpErrorMessage = undefined;
                        $scope.disableOtpResend = false;
                        $scope.showOtpErrorMessage = false;
                        $scope.$evalAsync();

                    }, 30 * 1000);
                }).catch(error => {
                    console.log(error);
                });
            $scope.stopLoading("#otpResendButton");
        }

        $scope.agreementAutoSubmit = async function (OtpNumber) {
            if (OtpNumber.length == 6) {
                $scope.submitOtpField(OtpNumber);
            }
        }

        $scope.submitOtpField = async function (OtpNumber) {
            $scope.showLoading('#otpSubmitButton');
            $scope.otpErrorMessage = undefined;
            $scope.showOtpErrorMessage = false;
            await WdHttpService._post_user_adviser_agreement_complete_signing($routeParams.fundName, $routeParams.adviserUsername, OtpNumber, $scope.isAdviserResearchAnalyst)
                .then(response => {
                    if (response.status == 'OTP_VERIFIED' || $scope.isAdviserResearchAnalyst) {
                        // final call to server side 
                        $scope.complete_agreement_signing(OtpNumber);
                    } else {
                        $scope.otpErrorMessage = "The OTP you entered is incorrect. Please enter the correct OTP or request for it to be re-sent.";
                        $scope.showOtpErrorMessage = true;
                        $scope.stopLoading('#otpSubmitButton');
                        $scope.$evalAsync();
                        $timeout(function () {
                            $scope.otpErrorMessage = undefined;
                            $scope.disableOtpResend = false;
                            $scope.showOtpErrorMessage = false;
                            $scope.$evalAsync();

                        }, 30 * 1000);
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.otpErrorMessage = error;
                    $scope.stopLoading('#otpSubmitButton');
                });
            $scope.stopLoading("#otpResendButton");
        }

        $scope.updateRiskHigherThanFund = async function () {
            return WdHttpService._put_risk_profile($scope.fundRiskValue, $routeParams.fundName, $routeParams.adviserUsername, $scope.userRiskValue);
        }

        $scope.redirectToPayment = async function () {
            if (!$scope.isEsignEnabled()) {
                $scope.stopLoading('#otpSubmitButton');
                await $('#otpModal').modal('hide');
                $('.modal-backdrop').remove();
            }
            $scope.removeSessionVaribles();
            let agreementSigningforPendingUsers = tempStorageService.get('agreementSigningforPendingUsers') == true ? true : false;
            if (agreementSigningforPendingUsers) {
                await $scope.agreementSigningforPendingUsers('/my-portfolio');
            } else {
                $location.url('/subscribe/' + $routeParams.adviserUsername + '/' + $routeParams.fundName);
            }
        }

        $scope.removeSessionVaribles = function () {
            sessionService.remove('user-risk');
            sessionService.remove('fund-risk');
            sessionService.remove('adviser-type');
        }

        $scope.redirectTo = async function (path) {
            await $scope.hideSignDeskErrorPopup();
            $scope.showPageLoader();
            $location.url(path);
        }

        $scope.redirectToHomepage = function () {
            $('#riskDisclaimer').modal('hide');
            $('.modal-backdrop').remove();
            $location.url('/wealthbaskets');
        }

        $scope.hideSignDeskErrorPopup = async function () {
            await $('#signdeskFailure').modal('hide');
            $('.modal-backdrop').remove();
        }

        $scope.startFallback = async function () {
            $scope.showPageLoader();
            await $scope.hideSignDeskErrorPopup();
            $location.path($location.path()).search({ 'fallback': "true" });
        }

        $scope.signdeskFailureRedirection = function () {
            window.location.href = '/wealthbaskets';
        }

        $scope.complete_agreement_signing = function (OtpNumber) {
            WdHttpService._post_user_adviser_agreement($routeParams.fundName, $routeParams.adviserUsername, OtpNumber, $scope.agreementText, $scope.isAdviserResearchAnalyst)
                .then(async (response) => {
                    if ($scope.isAdviserResearchAnalyst) {
                        await analyticsService._push_custom_event_data_to_datalayer('terms-of-service-signing-completed-' + $routeParams.adviserUsername.toLowerCase() + "-" + $routeParams.fundName.toLowerCase(), {});
                    } else {
                        await analyticsService._push_custom_event_data_to_datalayer('agreement-signing-completed-ria-' + $routeParams.adviserUsername.toLowerCase() + "-" + $routeParams.fundName.toLowerCase(), {});
                    }

                    if ($scope.isRiskHigher) {
                        await $scope.updateRiskHigherThanFund();
                    }
                    $scope.redirectToPayment();
                })
                .catch(error => {
                    console.log(error);
                    $scope.otpErrorMessage = "Something went wrong in processing your request, please try again later.";
                    $scope.showOtpErrorMessage = true;
                    $scope.stopLoading('#otpSubmitButton');
                });
        }
    }
]);